const PROD_PUBLIC_API_URL = "https://public.api.portal.delivo.ge/v1/docs";
const STAGING_PUBLIC_API_URL = "https://public.api.staging.portal.delivo.ge/v1/docs";

export const getPublicApiUrl = () => {
  const env = process.env.REACT_APP_ENVIRONMENT || "NOT_SET";
  return env.startsWith("prod") ? PROD_PUBLIC_API_URL : STAGING_PUBLIC_API_URL;
};
